import React, { useCallback } from 'react';

import { Url } from 'next/dist/shared/lib/router/router';
import Link from 'next/link';

import analytics from '@repo/analytics';
import { TransformedUseCase } from '@repo/editor/src/types';
import { withEventScope } from '@repo/event-processor';
import { H6 } from '@repo/ui/components/Typography';
import { themeStyle } from '@repo/ui/theming';

import { USECASES_SUB_CATEGORY } from 'global/analyticsEvents';
import { ALL_SLUG, buildTemplatesUrl } from 'global/utils/templateParams';

import { Wrapper } from './styles';
import { SubCategorySectionProps } from './type';

const SubCategorySection: React.FC<SubCategorySectionProps> = ({
  subCategories,
  currentSelection,
}) => {
  const {
    categorySlug: currentCategorySlug,
    subCategorySlug: currentSubCategorySlug,
  } = currentSelection;

  const buildSubCategoryUrl = useCallback(
    (subcategory: TransformedUseCase): Url =>
      buildTemplatesUrl(currentCategorySlug ?? '', subcategory.slug),
    [currentCategorySlug]
  );

  const handleUseCaseClick = ({
    name,
    slug,
  }: Pick<TransformedUseCase, 'name' | 'slug'>): void => {
    void analytics.track(USECASES_SUB_CATEGORY, { name, slug });
  };

  const subCategoriesFiltered: TransformedUseCase[] = [
    { name: 'Popular', slug: ALL_SLUG, total: 0, popularity: 0 },
    ...subCategories,
  ];

  return (
    <Wrapper>
      {subCategoriesFiltered?.map((subCategory) => {
        const isActive = subCategory.slug === currentSubCategorySlug;
        return (
          <Link
            key={subCategory.slug}
            data-testid={`usecases-subcategory--${subCategory.slug}`}
            href={buildSubCategoryUrl(subCategory)}
            onClick={(): void => handleUseCaseClick(subCategory)}
          >
            <H6
              color={isActive ? themeStyle.varInkMain : themeStyle.varInkMedium}
            >
              {subCategory.name}
            </H6>
          </Link>
        );
      })}
    </Wrapper>
  );
};

export default withEventScope(SubCategorySection, {
  feature: 'subCategorySection',
});
